<div class="edit-game">
    <h2 class="edit-game__title">
        {{ game?.id ? 'Játék szerkesztése' : 'Új játék hozzáadása' }}
    </h2>
    <form [formGroup]="gameForm" (ngSubmit)="saveGame()">
        <div class="field">
            <label class="label">Játék neve</label>
            <div class="control">
                <input type="text" class="input" formControlName="name">
            </div>
        </div>
        <div class="field">
            <label class="label">SKU előtag</label>
            <div class="control">
                <input type="text" class="input" formControlName="prefix">
            </div>
        </div>
        <div class="field">
            <label class="label">URL</label>
            <div class="control">
                <input type="text" class="input" formControlName="url">
            </div>
        </div>
        <div class="actions">
            <button 
                type="submit"
                class="button  is-primary"
                [ngClass]="{'is-loading': isSaving}"
                [disabled]="isSaving"
            >Mentés</button>
        </div>
    </form>
</div>